<template lang="pug">
div(:class="$style.headerCards")
  CategoryCard(
    title="Mudanzas"
    :link-path="preListingHouseMove"
    image-peeks-out
    animate-from="bottom"
    @cardClick="trackCardClick"
  )
    figure(:class="[$style.largeLoadingPlaceholder, 'flex justify-center items-center']")
      img(
        src="~/assets/img/homepage/removals-es.webp"
        alt="Mudanzas"
        style="--image-width: 420px; --image-height: 370px;"
      )
  CategoryCard(
    title="Mudanza Europa"
    :link-path="getAbsoluteUrl('enviar-objetos/mudanza-de-casa')"
    image-peeks-out
    animate-from="bottom"
    @cardClick="trackCardClick"
  )
    figure(:class="[$style.largeLoadingPlaceholder, 'flex justify-center items-center']")
      img(
        src="~/assets/img/homepage/international-moves.webp"
        alt="Mudanza Europa"
        style="--image-width: 420px; --image-height: 370px;"
      )
  CategoryCard(
    title="Muebles"
    :link-path="preListingFurniture"
    @cardClick="trackCardClick"
  )
    figure(:class="[$style.smallLoadingPlaceholder, 'flex justify-center items-center']")
      img(
        src="~/assets/img/homepage/furniture-es.webp"
        alt="Muebles"
        style="--image-width: 272px; --image-height: 215px;"
      )
  CategoryCard(
    title="Vehículos"
    :link-path="getAbsoluteUrl('enviar-objetos/mudanza-de-vehiculo')"
    @cardClick="trackCardClick"
  )
    figure(:class="[$style.smallLoadingPlaceholder, 'flex justify-center items-center']")
      img(
        src="~/assets/img/homepage/cars-es.webp"
        alt="Vehículos"
        style="--image-width: 272px; --image-height: 215px;"
      )
  CategoryCard(
    title="Otros"
    :link-path="getAbsoluteUrl('enviar-objetos')"
    @cardClick="trackCardClick"
  )
    figure(:class="[$style.smallLoadingPlaceholder, 'flex justify-center items-center']")
      img(
        src="~/assets/img/homepage/other-es.webp"
        alt="Otros"
        style="--image-width: 272px; --image-height: 215px;"
      )
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { v4Url } from "~/services/public/Listing"

interface ComponentData {
  preListingFurniture: string
  preListingHouseMove: string
}

export default defineComponent({
  name: "HeaderCardsES",
  data(): ComponentData {
    return {
      preListingFurniture: "/es/" + v4Url.preListing.furniture,
      preListingHouseMove: "/es/" + v4Url.preListing.houseMove
    }
  },
  methods: {
    trackCardClick(title: string) {
      this.$snowplow.trackCategoryCardClick(title)
    },
    getAbsoluteUrl(path: string): string {
      return `${this.$config.public.v4Host.replace("com", this.$i18n.locale)}/${path}`
    }
  }
})
</script>

<style module lang="css">
.headerCards {
  @apply grid gap-ds-md md:gap-ds-ml;
  display: grid;
  grid-auto-rows: min-content;
  grid-template-rows: auto auto; /* Two rows */
  grid-template-columns: repeat(6, 1fr); /* First row with two equal columns */

  /* Explicitly place the first two children in the first row */

  > :nth-child(1) {
    grid-column: 1 / 4;
  }

  > :nth-child(2) {
    grid-column: 4 / 7;
  }

  > :nth-child(3) {
    grid-column: 1 / 3;
  }

  > :nth-child(4) {
    grid-column: 3 / 5;
  }

  > :nth-child(5) {
    grid-column: 5 / 7;
  }

  .largeLoadingPlaceholder {
    aspect-ratio: 42 / 37; /* Fixes layout shift prior to images loading */
  }

  .smallLoadingPlaceholder {
    aspect-ratio: 272 / 215; /* Fixes layout shift prior to images loading */
  }
}
</style>
